export const routes = {
  otpUrl: "/otp",
  loginUrl: "/signin",
  search: "/search",
  faqUrl: "/faq",

  aboutUrl: "/about",
  craftsmanshipUrl: "/craftsmanship",
  refundUrl: "/refund",
  privacyUrl: "/privacy",
  contactUrl: "/contact",
  retailerQueryUrl: "/retailer-query",
  sellGoldtUrl: "/sellGold",
  designCadUrl: "/design-and-cad",
  sellGoldQuoteUrl: "/sell-gold/get-a-quote",
  walletUrl: "/walletHistory",
  coinsUrl: "/rewardHistory",
  likeUrl: "/wishlist",
  orderUrl: "/order",
  signupUrl: "/user",
  settingUrl: "/setting",
  homepageUrl: "/",
  shoppingUrl: "/cart",
  thankyouUrl: "/thankyou",
  walletAdded: "/walletAdded",
  thankyouMobileUrl: "/thankyouMobile",
  pendingPayment: "/payment-pending",
  paymentError:"/payment-error",
  addressUrl: "/address",
  catagoryUrl: "/product",
  orderviewUrl: "/orderview",
  summeryUrl: "/order-summary",
  addcartUrl: "/product-detail/:name",
  notificationUrl: "/notificationHistory",
  accountUrl: "/my-account",
  error:'/error',
  forgotPasswordUrl: "/forgot-password",
  resetPasswordUrl: "/reset-password",
};



